import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { empty } from 'rxjs/observable/empty';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { AcoesService } from '../../acoes/acoes.service';
import { FormUtil } from '../../base/util/form.util';
import { Field } from '../../base/vo/formulario';
import { Gto } from '../../base/vo/gto';
import { SalvaTokenGto } from '../../base/vo/salva-token-gto';
import { ValidarTokenGtoRequest } from '../../base/vo/tokenGto';
import { GtoTokenService } from '../gto-token.service';


@Component({
  selector: 'app-validate-token',
  templateUrl: './validate-token.component.html',
  styleUrls: ['./validate-token.component.scss']
})
export class ValidateTokenComponent implements OnInit, OnDestroy {

  @Input() gto: Gto;

  @Output() readonly stepEmitter: EventEmitter<number> = new EventEmitter();

  private subs: Subscription[] = [];

  public loading = false;
  public formGroup: FormGroup;
  public fields: Field[] = [
    {
      controlName: 'token',
      label: 'Número do Token',
    },
    {
      controlName: 'data',
      label: 'Data do Token',
    }
  ];
  public maxDate: Date = new Date();
  public minDate: Date;

  constructor(
    private readonly acoesService: AcoesService,
    private readonly formBuilder: FormBuilder,
    private readonly gtoTokenService: GtoTokenService,
    private readonly messageService: MessageService,
    private readonly router: Router,
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      token: ['', [Validators.required]],
      data: ['', [Validators.required]],
    });

    this.subs.push(
      this.formGroup.controls['token'].valueChanges.pipe(
        tap(value => this.formGroup.controls['token'].patchValue(value.toUpperCase(), { emitEvent: false }))
       ).subscribe()
    );

    this.minDate = new Date(this.getDataAutorizacao());
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  private getDataAutorizacao() {
    return this.gto.dataPrimeiraAut ? this.gto.dataPrimeiraAut : this.gto.dataProtocolo;
  }

  private validarTokenGto() {
    const validarTokenGtoRequest: ValidarTokenGtoRequest = {
      consumer: {
        canalConsumidor: 'portalodonto',
        processo: 'confirmação de GTO',
        tokenExpiry: 1
      },
      token: {
        token: this.formGroup.controls.token.value
      }
    };

    return this.gtoTokenService.validarTokenGto(validarTokenGtoRequest);
  }

  private validate() {
    this.loading = true;

    this.subs.push(this.validarTokenGto().pipe(
      catchError(errorResponse => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Erro ao validar token.', detail: errorResponse.error.errors.details });

        return empty();
      }),
      mergeMap(_ => {
        const salvaTokenGto: SalvaTokenGto = {
          codigoPrestador: +this.gto.codigoPrestadorExecutante,
          dataToken: this.formGroup.controls.data.value,
          idToken: this.gto.idToken,
          numeroGTO: +this.gto.numero,
          numeroToken: this.formGroup.controls.token.value
        };

        return this.gtoTokenService.salvarTokenGto(salvaTokenGto);
      }),
      tap(_ => {
        this.loading = false;
        this.acoesService.setCanGoToFinalizar(true);
        this.gtoTokenService.setCanOpenModalTokenOnFinalizar(true);
        this.router.navigate([`detalhagto/${this.gto.numero}/finalizar`]);
      },
        _ => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro ao salvar token.', detail: 'Tente novamente mais tarde.' });
        })
    ).subscribe());
  }

  public submit() {
    FormUtil.checkFormValidations(this.formGroup);
    if (this.formGroup.valid) {
      this.validate();
    }
  }

  public changeStep(step: number) {
    this.stepEmitter.emit(step);
  }

  public goToDetalhe() {
    if (this.router.url.includes('/detalhagto')) {
      this.gtoTokenService.setReloadDetalhaGTO(true);
    } else {
      this.router.navigate([`detalhagto/${this.gto.numero}`]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gto-token/validate-token/validate-token.component.ts